import { useSendCommandAsync } from '@/_core/cqrs/use';
import { RealTimeAction } from '@/_core/fluxstore/types';
import { createDeleteAnnotationCommand } from '../../../api/commands/factory/createAnnotationCommands';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class DeleteAnnotation extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'DeleteAnnotation';

    public constructor(public id: string) {
        super(DeleteAnnotation.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: DeleteAnnotation): Promise<boolean> => {
    useSendCommandAsync(action, {
        createCommand: async () => await createDeleteAnnotationCommand(action),
    });

    return true;
};

const reducer = (state: StorymapState, action: DeleteAnnotation): void => {
    const annotation = state.annotations.find(x => x.id == action.id);
    state.annotations.filter(x => x.order > annotation.order).forEach(x => x.order--);
    state.annotations = state.annotations.filter((x) => x.id !== annotation.id);
};

//@ts-ignore
registerMiddleware(DeleteAnnotation.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(DeleteAnnotation.ACTION_TYPE, reducer);
